import * as types from "./dataActionTypes";
import api from "./dataApi";

export function clearDataCount(model) {
  return {
    type: types.CLEAR_DATA_COUNT,
    model,
  };
}

export function clearDataList(model) {
  return {
    type: types.CLEAR_DATA_LIST,
    model,
  };
}

export function clearDataFile(model) {
  return {
    type: types.CLEAR_DATA_FILE,
    model,
  };
}

export function clearS3DataFile(model) {
  return {
    type: types.CLEAR_S3_DATA_FILE,
    model,
  };
}

export function getDataCount(model, filters, sectionType) {
  return {
    type: types.GET_DATA_COUNT,
    model,
    promise: api.getDataCount(model, filters, sectionType),
    payload: { model },
  };
}

export function getGraphQL(model, body, sortBy) {
  return {
    type: types.GRAPHQL,
    model,
    promise: api.getGraphQL(model, body),
    payload: { model },
    sortBy,
  };
}

export function getDataList(
  model,
  offset = 0,
  limit = 10,
  q = "",
  sortBy = [],
  filters = [],
  customHeaders = {},
  metadata = {},
  fields = "*",
  sectionType,
  additionalParams,
  skipClearActive = false
) {
  return {
    type: types.GET_DATA_LIST,
    model,
    promise: api.getDataList(
      model,
      offset,
      limit,
      q,
      sortBy,
      filters,
      customHeaders,
      fields,
      sectionType,
      additionalParams,
    ),
    q,
    sortBy,
    filters,
    metadata,
    payload: { model },
    skipClearActive
  };
}
export function getPagelessDataList(
  model,
  offset = 0,
  limit = 10,
  q = "",
  sortBy = [],
  filters,
  customHeaders,
  metadata,
  fields,
  sectionType
) {
  return {
    type: types.GET_PAGELESS_DATA_LIST,
    model,
    promise: api.getDataList(
      model,
      offset,
      limit,
      q,
      sortBy,
      filters,
      customHeaders,
      fields,
      sectionType
    ),
    q,
    sortBy,
    filters,
    metadata,
    payload: { model },
  };
}

export function createDataItem(model, item, customHeaders, options, query) {
  return {
    type: types.CREATE_DATA_ITEM,
    model,
    promise: api.postDataItem(model, item, customHeaders, options, query),
  };
}

export function deleteDataItem(model, id, customHeaders) {
  return {
    type: types.DELETE_DATA_ITEM,
    model,
    promise: api.deleteDataItem(model, id, customHeaders),
  };
}

export function getDataItem(model, id, query, customHeaders, doesNotHaveId=false, overridablePath=null) {
  return {
    type: types.GET_DATA_ITEM,
    model,
    promise: api.getDataItem(model, id, query, customHeaders, doesNotHaveId, overridablePath),
    payload: { model },
  };
}

export function getDataFile(model, path, filters, customHeaders) {
  return {
    type: types.GET_DATA_FILE,
    model,
    promise: api.getDataFile(model, path, filters, customHeaders),
    payload: { model },
  };
}

export function getS3DataFile(model, path, query, customHeaders) {
  return {
    type: types.GET_S3_DATA_FILE,
    model,
    promise: api.getS3DataFile(model, path, query, customHeaders),
    payload: { model },
  };
}

export function postDataFile(model, path, item, customHeaders) {
  return {
    type: types.POST_DATA_FILE,
    model,
    promise: api.postDataFile(model, path, item, customHeaders),
    payload: { model },
  };
}

export function updateDataItem(model, data, customHeaders) {
  return {
    type: types.UPDATE_DATA_ITEM,
    model,
    promise: api.patchDataItem(model, data, customHeaders),
  };
}

export function putDataItem(model, data, customHeaders) {
  return {
    type: types.UPDATE_DATA_ITEM,
    model,
    promise: api.putDataItem(model, data, customHeaders),
  };
}

export function simplePost({ model, data, customHeaders }) {
  return {
    type: types.SIMPLE_POST,
    model,
    promise: api.simplePost(model, data, customHeaders),
  };
}

export function getRelationshipItems(model, id, customHeaders) {
  return {
    type: types.GET_RELATIONSHIP_ITEMS,
    model,
    promise: api.getRelationshipItems(model, id, customHeaders),
    payload: { model },
  };
}

export function updateLocalData(model, values) {
  return {
    type: types.UPDATE_LOCAL_DATA,
    model,
    values,
  };
}



// WEBPACK FOOTER //
// ./src/utils/data/dataActions.js